export enum LastEventType {
  MONITORING = 'MONITORING',
  SPRAY = 'SPRAY',
  ENABLE = 'ENABLE'
}
